import { FeatureFlagEnum, FeatureFlags } from "@finway-group/shared/lib/models"
import { TenantFeatureFlagUpdateRequest } from "@finway-group/shared/lib/models/featureFlags/tenantFeatureFlagUpdateRequest.interface"
import { useMutation } from "@tanstack/react-query"
import { useDispatch } from "react-redux"
import { AuthnService } from "~Shared/services"
import { setFeatureFlags } from "~Shared/store/actions/featureFlags/featureFlagsActions"
import { decodeAccessToken } from "~Shared/utils/auth.utils"
import { queryPatch } from "~Shared/utils/reactQuery.utils"

const MODEL = "tenant"

export const useUpdateTenantFeatureFlag = () => {
    const dispatch = useDispatch()

    const refreshFeatureFlags = async () => {
        const { accessToken } = await AuthnService.silentRefreshWithoutLogout()

        const decodedToken = decodeAccessToken(accessToken)
        const featureFlags = new FeatureFlags(decodedToken.featureFlags)

        dispatch(setFeatureFlags(featureFlags.getFlagsObject()))
    }

    return useMutation(
        ({ featureFlag, isEnabled }: { featureFlag: FeatureFlagEnum; isEnabled: boolean }) =>
            queryPatch(`/${MODEL}/${AuthnService.getCurrentTenantId()}/flags`, {
                [featureFlag]: isEnabled,
            } as TenantFeatureFlagUpdateRequest),
        {
            onSuccess: refreshFeatureFlags,
        },
    )
}
